<article class="select-email-wrapper" *ngIf="!enableValidateCode">
  <h2 class="text">¿Dónde quieres recibir el código para restablecer la contraseña?</h2>
  <section>
    <div class="container-options">
      <div class="option" *ngFor="let option of options">
        <label class="container-checked">
          <input type="radio" (change)="selectOption(option)" name="radio">
          <span class="checkmark"></span>
        </label>
        <img class="img" [src]="getImageMethod(option.type)" alt="">
        <div>
          <p class="data-label">{{getLabelMethod(option.type)}}</p>
          <p class="data-option"><strong>{{option.data}}</strong></p>
        </div>
      </div>

      <div class="option">
        <label class="container-checked">
          <input type="radio" (change)="selectOption(whatsAppNumber)" name="radio">
          <span class="checkmark"></span>
        </label>
        <img class="img" src="assets/svg/whatsapp.png" alt="Whatsapp" width="22">
        <div>
          <p class="data-label">Mensaje por medio de whatsapp</p>
          <p class="data-option"><strong>{{whatsAppNumber.data}}</strong></p>
        </div>
      </div>

    </div>
  </section>
  <section class="container-button">
    <app-button [spinnerBlue]="true" [title]="'Enviar código'" [isDisabled]="!disableButton || isLoading" [customClasses]="'main full-width sign-up-button'" [isLoading]="isLoading" (click)="sendMessage()"></app-button>
  </section>
</article>

<app-validate-code *ngIf="isModal && enableValidateCode" (openSelectModal)="openSelectModal($event)" [listCustomer]="customer" [choice]="dataMethodSelect" [from]="'remember'" (validateCode)="onValidateCode($event)" (loggedIn)="onSuccess($event)"></app-validate-code>
